import $ from 'jquery';
import uniqid from 'uniqid';
import restlog from '../Entity/restlog';

const WebServiceGet = (restPath, payload, callbackSuccess = ()=>{}, callbackError = ()=>{}) => {

  var log = restlog()
  log.uid = uniqid.time()
  log.process = "WebServiceGet"
  log.decription = "Dummy"

  $.ajax(
    {
      type: 'GET',
      url: restPath,
      xhrFields: {
        withCredentials: true
      },
      data: {
        s:payload
      },
      success: (data) => {
        callbackSuccess(data)
      },
      error: (data) => {
        callbackError(data)
      }
    }
  )

}
export default WebServiceGet;
